import { render } from "./productName.vue?vue&type=template&id=2954812e&ts=true"
import script from "./productName.vue?vue&type=script&lang=ts"
export * from "./productName.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__